'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '/services-page' },
  { label: 'About Us', href: '/about-us-page' },
];

export default function MarketingNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-primary shadow-nav' : 'bg-transparent'
      }`}
    >
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 flex items-center justify-between h-16">
        <Link href="/" className="flex items-center gap-2">
          <AppLogo size={36} className="rounded-full overflow-hidden" />
          <span className="font-display text-xl font-700 text-white tracking-tight">
            DakaPay
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks?.map((link) => (
            <Link
              key={`nav-${link?.label}`}
              href={link?.href}
              className="text-white/80 hover:text-white text-sm font-500 transition-colors duration-150"
            >
              {link?.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link
            href="/sign-up-login-screen"
            className="text-white/90 hover:text-white text-sm font-600 transition-colors"
          >
            Sign In
          </Link>
          <Link
            href="/sign-up-login-screen"
            className="btn-primary px-5 py-2 rounded-lg text-sm"
          >
            Get Started
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden text-white p-2"
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {mobileOpen && (
        <div className="md:hidden bg-primary border-t border-white/10 px-6 pb-6 animate-fade-in">
          <nav className="flex flex-col gap-4 pt-4">
            {navLinks?.map((link) => (
              <Link
                key={`mobile-nav-${link?.label}`}
                href={link?.href}
                onClick={() => setMobileOpen(false)}
                className="text-white/80 hover:text-white text-sm font-500"
              >
                {link?.label}
              </Link>
            ))}
            <Link
              href="/sign-up-login-screen"
              onClick={() => setMobileOpen(false)}
              className="btn-primary px-5 py-2.5 rounded-lg text-sm text-center mt-2"
            >
              Get Started
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}